export enum BiddingErrorCodes {
    USER_ALREADY_WINNING = 9000,
    MINIMUM_BID_NOT_MET = 9010,
    WATCHER_NOT_FOUND = 9020,
    BID_NOT_FOUND = 9030,
    AUCTION_NOT_PUBLISHED = 9040,
    BIDDING_TIME_COMPLETED = 9050,
    BIDDING_DATA_FOUND = 9060,
    BID_AMOUNT_EXISTS = 9070,
    REDUCED_PROXY_BID_AMOUNT_ERROR = 9080,
    PROXY_BIDDING_UNAVAILABLE = 9090,
    CURRENT_HIGH_BIDDER = 9100,
    ACCOUNT_MAPPINGS_NOT_FOUND_IN_BIDDING_DATA = 9110,
    MAX_BID_AMOUNT_EXCEEDED_ERROR = 9120,
    VALID_PROFILE_NOT_FOUND = 9130,
    USER_IS_SUSPENDED = 9140,
    USER_IS_RESTRICTED = 9150,
    USER_IS_PENDING = 9160,
    BID_CREATION_FAILED = 9170,
    BID_COLLISION_OCCURRED = 9180,
    INVALID_BID_ATTEMPT = 9190,
    BID_UPDATE_FAILED = 9200,
    LOT_UNDER_MAINTENANCE = 9095,
}
